<div
  class="status-badge"
  [ngClass]="{
    grey: color === 'grey',
    blue: color === 'blue',
    red: color === 'red',
    orange: color === 'orange',
    green: color === 'green',
  }"
>
  <span>{{ text }}</span>
  <ds-avatar
    *ngIf="user != null"
    size="md"
    [name]="user.full_name"
    [image]="user.pictureUrl"
  />
</div>
